import { useTranslation } from 'react-i18next'

import styles from './AgentVerificationBulkRejectModal.module.scss'
import { BulkRejectRowError } from '@percent/admin-dashboard/api/actions/agentVerification/agentVerification.types'
import { Table, TableBody, TableCell, TableProvider, TableRow } from '@percent/lemonade'

// Takes only the fields it shows, so the bulk release can list its row errors, which carry no code.
type RowError = Pick<BulkRejectRowError, 'row' | 'field' | 'fieldValue' | 'message'>

export function BulkRejectRowErrorsTable({ rowErrors }: Readonly<{ rowErrors: RowError[] }>) {
  const { t } = useTranslation()

  return (
    <div className={styles.resultTableContainer} data-testid="av-bulk-reject-row-errors-table">
      <TableProvider
        columns={[
          { id: t('dialog.avBulkReject.error.column.row') },
          { id: t('dialog.avBulkReject.error.column.field') },
          { id: t('dialog.avBulkReject.error.column.value') },
          { id: t('dialog.avBulkReject.error.column.problem') }
        ]}
        totalResults={rowErrors.length}
        isLoading={false}
        illustration="no-results"
        emptyTableTitle={t('dialog.avBulkReject.error.title')}
      >
        <Table>
          <TableBody>
            {rowErrors.map(rowError => (
              <TableRow key={`${rowError.row}-${rowError.field}`}>
                <TableCell>{rowError.row}</TableCell>
                <TableCell>{rowError.field}</TableCell>
                <TableCell>{rowError.fieldValue ?? ''}</TableCell>
                <TableCell>{rowError.message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableProvider>
    </div>
  )
}
